module.exports = __webpack_public_path__ + "static/media/maillogo.795dd23d.svg";